var _rect, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStopTram = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 8,
  x: 14.5,
  y: 22,
  fill: "#333",
  rx: 1.5
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 13,
  r: 11
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M18.18 19.2v-.6l-.74.1v.5h-2.86v-.5l-.74-.1v.6h-.6c-.22 0-.36.18-.36.36 0 .26.14.42.36.42h5.54c.18 0 .38-.16.38-.42 0-.18-.2-.36-.38-.36zm1-10.78c-.1-.24-.24-.36-.48-.42-.86-.22-1.48-.3-2.28-.32v-.7h1.48c.2 0 .36-.18.36-.38 0-.24-.16-.42-.36-.42h-3.76a.41.41 0 0 0-.42.42c0 .2.18.38.42.38h1.46v.7c-.82.02-1.48.1-2.28.32-.28.08-.42.18-.54.42l-.34.82c-.1.24-.1.58-.1.84v7.2c0 .36.24.58.6.64 1.08.22 2.02.3 3.06.3 1 0 1.96-.08 3.08-.3.34-.06.6-.28.6-.64v-7.2c0-.26-.06-.6-.16-.84zm-5.66 8.14c-.26 0-.46-.18-.46-.44 0-.28.2-.5.46-.5.28 0 .48.22.48.5 0 .26-.2.44-.48.44m-.44-6.64h5.82v4.86c-.76.22-1.84.36-2.9.36-1.04 0-2.12-.16-2.92-.36zm5.46 6.64a.42.42 0 0 1-.44-.44c0-.28.18-.5.44-.5.28 0 .5.22.5.5 0 .26-.22.44-.5.44"
})));
export { SvgStopTram as ReactComponent };